/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

   /**
   * show / hide tabs
   */
   function registerTabClickHander () {
    /**
     * @param {string} tabName
     * @param {NodeList} tabList
     */
    function toggleCurrent(tabName, tabList) {
      for (let i = 0; i < tabList.length; i += 1) {
        const tab = tabList[i];

        if (tab.dataset.tab === tabName || tab.id === tabName) {
          if (tab.parentElement.nodeName === 'LI') {
            tab.parentElement.classList.add('current');
          } else {
            tab.classList.add('current');
          }
        } else {
          if (tab.parentElement.nodeName === 'LI') {
            tab.parentElement.classList.remove('current');
          } else {
            tab.classList.remove('current');
          }
        }
      }
    }

    /**
     * @param {Node} tabLinks
     */
    function toggleExpansion(tabsList) {
      if (tabsList.classList.contains('collapsed')) {
        tabsList.classList.remove('collapsed');
        tabsList.classList.add('expanded');

        return;
      }

      if (tabsList.classList.contains('expanded')) {
        tabsList.classList.remove('expanded');
        tabsList.classList.add('collapsed');

        return;
      }
    }

    const tabsList = document.querySelector('.tabs, [data-tab-list]');
    if (!tabsList) {
      return;
    }

    tabsList.addEventListener('click', function(e) {
      const { target } = e;
      if (target.closest('.current')) {
        e.preventDefault();
      }

      toggleExpansion(tabsList);

      const tabName = target.dataset.tab;
      if (!tabName) {
        return;
      }

      const tabLinks = document.querySelectorAll('[data-tab]');
      toggleCurrent(tabName, tabLinks);

      const tabs = document.querySelectorAll('.tab-content');
      toggleCurrent(tabName, tabs);
    });
  }

  /**
   * show / hide variant-specific product description
   */
  function registerVariantDescriptionChanger() {
    /**
     *
     * @param {?NodeList} elements
     * @param {string} attributeName
     * @returns {Object.<string, Node>} hashByElementName
     */
    function getHashOfElementsByDataAttribute(elements, attributeName) {
      const hash = {};

      for (let i = 0; i < elements.length; i += 1) {
        const element = elements[i];
        const value = element.dataset[attributeName];

        if (value) {
          hash[element.dataset[attributeName]] = element;
        }
      }

      return hash;
    }

    /**
     * @param {string} currentlySelected
     * @param {NodeList} variantDescriptions
     * @param {Object<string, node>} variantLabelHash
     * @param {?Node} labelSpan
     */
    function toggleVisibilityOfVariants(
      currentlySelected,
      variantDescriptions,
      variantLabelHash,
      labelSpan
      ) {
        // iterate over the variant descriptions
        // hide the ones that aren't selected;
        // show the one that is.
        for (let i = 0; i < variantDescriptions.length; i += 1) {
          const variant = variantDescriptions[i];

          if (variant.dataset.color === currentlySelected) {
            variant.classList.add('show');
          } else {
            variant.classList.remove('show');
          }
        }

        // if there's supplemental label data,
        // show it.
        const labelToShow = variantLabelHash[currentlySelected];
        if (labelToShow && labelSpan) {
          const labelText = ' - ' + labelToShow.innerHTML;
          setTimeout(function() {
            labelSpan.appendChild(document.createTextNode(labelText));
          }, 0);
        }
    }

    const productForm = document.querySelector('.product__content');
    if (!productForm) {
      return;
    }

    const variantFieldset = productForm.querySelector('.product__selectors');
    if (variantFieldset) {
      const radio = variantFieldset.querySelector('input[type=radio]');
      const variantDescSections = document.querySelectorAll('.product__content .variant-desc');

      // Convert nodelists into hashes
      const labelDescSections = document.querySelectorAll('[data-color-name]');
      const labelDescHash = getHashOfElementsByDataAttribute(labelDescSections, 'colorName');

      // show the section for the default value
      const radioName = radio.name;
      const labelSpan = variantFieldset.querySelector('legend [data-option-value]');
      if (radioName) {
        toggleVisibilityOfVariants(
          radio.value,
          variantDescSections,
          labelDescHash,
          labelSpan
        );
      }

      variantFieldset.addEventListener('change', function(e) {
        const { target } = e;

        toggleVisibilityOfVariants(
          target.value,
          variantDescSections,
          labelDescHash,
          labelSpan
        );
      });
    }
  }

  function hideOldDescriptionTabs() {
    const productDesc = document.querySelector('.product__description__content__entry');
    if (productDesc) {
      const truncateAt = productDesc.innerHTML.indexOf("<!-- 371 tabs -->")
      if (truncateAt > 0) {
        productDesc.innerHTML = productDesc.innerHTML.slice(0, truncateAt);
      }
    }
  }

  function restoreProductImageWhenLeavingSwatches() {
    const collections = document.querySelectorAll('.product-grid');

    for (let i = 0; i < collections.length; i += 1) {
      const collection = collections[i];

      const swatchGroups = collection.querySelectorAll('[data-grid-swatch-form]');

      for (let j = 0; j < swatchGroups.length; j += 1) {
        const swatchGroup = swatchGroups[j];

        swatchGroup.addEventListener('mouseleave', function(e) {
          const productHolder = e.target.closest('.product-item');

          if (!productHolder) {
            return;
          }

          const imageHolder = productHolder.querySelector('a.product-link');

          if (imageHolder) {
            const visibleImage = imageHolder.querySelector('.is-visible');

            if (visibleImage) {
              visibleImage.classList.remove('is-visible');
            }
          }
        });
      }



    }
  }

  function registerFooterMenuAccordions() {
    const footer = document.querySelector('footer');
    if (!footer) {
      return;
    }

    footer.addEventListener('click', function(e) {
      const { target } = e;

      if (target.matches('button[aria-expanded]')) {
        const list = target.nextElementSibling;

        if (target.getAttribute('aria-expanded') === 'true') {
          target.setAttribute('aria-expanded', 'false');
          list.style.removeProperty('max-height');
        } else {
          if (list.scrollHeight) {
            list.style.maxHeight = `${list.scrollHeight}px`;
          }
          target.setAttribute('aria-expanded', 'true');
        }

      }
    });
  }

  function registerPredictiveSearchButtonHandlers() {
    const searchElements = document.querySelectorAll('predictive-search');

    for (let i = 0; i < searchElements.length; i += 1) {
      const searchElement = searchElements[i];
      const form = searchElement.querySelector('form');

      if (!form || !form.q) {
        return;
      }

      searchElement.addEventListener('click', function (e) {
        if (e.target.matches('button[value="product"]')) {
          form.q.value = 'title:' + form.q.value;
        }
      });
    }
  }

  function registerCustomSlideshowWindowListeners() {
    const customSlideshows = document.querySelectorAll('.slideshow__slider-blocks');

    function handleMediaChange(mediaQueryEvent) {
      const cellsToKeep = mediaQueryEvent.matches ? '.show-mobile' : '.show-desktop';

      for (let i = 0; i < customSlideshows.length; i += 1) {
        const slideshow = customSlideshows[i];
        let slideshowOptions = slideshow.dataset.options;
        try {
          const parsedOptions = JSON.parse(slideshowOptions);
          parsedOptions.cellSelector = cellsToKeep;

          slideshowOptions = parsedOptions;
        } catch {}

        let flickity = window.themeVendor.Flickity.data(slideshow);
        if (flickity) {
          flickity.destroy();
        }
        flickity = new window.themeVendor.Flickity(slideshow, slideshowOptions);
        setTimeout(() => {
          flickity.resize();
        });
      }
    }

    if (customSlideshows.length === 0) {
      return;
    }

    const mediaQueryList = window.matchMedia('(max-width: 749px)');
    handleMediaChange(mediaQueryList);

    mediaQueryList.addEventListener('change', handleMediaChange);
  }

  function registerBogoListeners() {
    // if there is no bogo...
    const bogoProducts = window.theme.custom && window.theme.custom.bogoProducts;
    if (!bogoProducts) {
      return;
    }

    const bogos = bogoProducts.map((productGid) => {
      const productParts = productGid.split('/');
      if (productParts.length > 0) {
        return productParts[productParts.length - 1];
      } else {
        return null;
      }
    });

    document.addEventListener('theme:product:add', (e) => {
      const response = e.detail.response;
      const variantId = response.variant_id;
      const productId = response.product_id;
      const quantity = response.quantity;

      // if someone purchased more than one,
      // they will qualify for the bogo, so no
      // need to continue
      if (quantity !== 1) {
        return;
      }

      // if we're not working with a product
      // in the bogo list, stop
      let isBogo = false;
      for (let i = 0; i < bogos.length; i += 1) {
        const bogo = bogos[i];

        if (bogo === productId.toString()) {
          isBogo = true;
          break;
        }
      }

      if (!isBogo) {
        return;
      }

      const cartItemHolder = window.cart.itemsHolder;
      const existingItem = cartItemHolder.querySelector('[data-item^="' + variantId + '"]');

      // if the item is already in the cart
      // don't double up--we're already doing that
      if (existingItem) {
        return;
      }

      const newItem = document.createElement('span');
      newItem.setAttribute('data-item-index', 1);
      window.cart.updateCart({ quantity: 2 }, newItem);
    });
  }

  function registerAccordionImages() {
    const collapsibleElements = document.querySelector('collapsible-elements');
    if (!collapsibleElements) {
      return;
    }

    const parentBrickSection = collapsibleElements.closest('.brick__section');
    if (!parentBrickSection) {
      return;
    }

    const images = parentBrickSection.querySelectorAll('.brick__block__image');

    const handler = function (e) {
      const closestTrigger = e.target.closest('[data-collapsible-trigger]');
      if (!closestTrigger) {
        return;
      }

      setTimeout(() => {
        const openElement = collapsibleElements.querySelector('[open=true]');
        const title = openElement ? openElement.dataset.title : 'default';
        console.debug(title);

        for (let i = 0; i < images.length; i += 1) {
          const image = images[i];
          if (image.dataset.title === title) {
            image.classList.remove('hide');
          } else {
            image.classList.add('hide');
          }
        }
      }, 10);
    }

    collapsibleElements.addEventListener('click', handler);
    collapsibleElements.addEventListener('keydown', handler);
  }

  registerTabClickHander();
  registerVariantDescriptionChanger();
  hideOldDescriptionTabs();
  restoreProductImageWhenLeavingSwatches();
  registerFooterMenuAccordions();
  registerPredictiveSearchButtonHandlers();
  registerCustomSlideshowWindowListeners();
  registerBogoListeners();
  registerAccordionImages();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
